module.exports = __webpack_public_path__ + "img/burger.06b81000.svg";